<template>
    <section class=" h-full  w-full flex flex-wrap bg-gray-50 justify-start  ">
    
        <!--<div v-if="!IsMov()" class="w-full h-24 bg-gray-100 flex flex-wrap content-center justify-start px-2">
           
            <div class="">
                <el-pagination v-model:currentPage="pagina" small background layout="prev, pager, next" :page-size="data['per_page']" :total="Number(data['total'])" @current-change="pageChangue" class="" />
    
            </div>
    
        </div>
        <div v-if="IsMov()" class="w-full h-24 bg-gray-100 flex flex-wrap content-center justify-end px-2 ">
    
            <div class="w-10/12 h-12 justify-end content-center flex flex-wrap ">
                <el-pagination v-model:currentPage="pagina" small background layout="prev, pager, next" :page-size="data['per_page']" :total="Number(data['total'])" @current-change="pageChangue" class="" />
    
            </div>
           
    
        </div>-->
  
        <!-- Filtro de fechas -->
        <div class="w-full p-4 bg-white border-b border-gray-200 shadow-sm">
            <div class="flex flex-wrap gap-4 items-center">
                <div class="flex flex-col">
                    <label class="text-sm font-medium text-gray-700 mb-1">Fecha Inicio</label>
                    <input 
                        type="date" 
                        v-model="fecha[0]" 
                        @change="getData()"
                        class="rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm"
                    />
                </div>
                <div class="flex flex-col">
                    <label class="text-sm font-medium text-gray-700 mb-1">Fecha Fin</label>
                    <input 
                        type="date" 
                        v-model="fecha[1]" 
                        @change="getData()"
                        class="rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm"
                    />
                </div>
                <div class="flex flex-col">
                    <label class="text-sm font-medium text-gray-700 mb-1">&nbsp;</label>
                    <div class="flex gap-2">
                        <button 
                            @click="setCurrentMonth()" 
                            class="px-3 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-medium">
                            Mes Actual
                        </button>
                        <button 
                            @click="setPreviousMonth()" 
                            class="px-3 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 text-sm font-medium">
                            Mes Anterior
                        </button>
                        <button 
                            @click="setLast3Months()" 
                            class="px-3 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 text-sm font-medium">
                            Últimos 3 Meses
                        </button>
                    </div>
                </div>
            </div>
        </div>
        
    <VistaDetallePedido 
        v-if="data && data.data" 
        :cotizaciones="data.data"
        @instalacion-marcada="onInstalacionMarcada">
    </VistaDetallePedido>
        <!--<Tabla v-bind:key="reftable" v-if="data.hasOwnProperty('data')" :add="false" :columns="headings" :rows="data.data" :filtros="['email','phone','id']" :buscarp="buscar" :filtroApi="true" :paginate="true" :page="{
                page:data.current_page,
                total:data.last_page
              }" />-->
    
       
    
    </section>
    </template>
    
        
        
    <script>
    import {
        emitter
    } from "../../../mitt.js";
    import {
        useUserStore
    } from '../../../stores/user'
    import VistaDetallePedido from "@/components/VistaDetallePedidoInstalacion_origen_productos.vue";
    import generales from "@/functions/generales";
    import cotizacionesMixin from "@/functions/cotizaciones";
    import cotizaciones from "@/Services/cotizaciones";
    
    import {
        filter
    } from "lodash";
    export default {
        components: {
          
         
            VistaDetallePedido
        },
        mixins: [generales, cotizacionesMixin],
        data() {
            const user = useUserStore()
    
            return {
                headings: [
    
                    {
                        key: 'id',
                        name: '# Cot',
                        show: true
                    },
                    {
                        key: 'idventa',
                        name: '# venta',
                        show: true
                    },
                    {
                        key: 'fecha_ago',
                        name: 'Fecha Cotización',
                        show: true
                    },
    
                    {
                        key: 'clientes',
                        name: 'Cliente',
                        show: true
                    },
    
                    {
                        key: 'usuario',
                        name: 'Usuario',
                        show: true
                    },
                    {
    
                        key: 'status_produccion',
                        name: 'Estatus producción',
                        show: true
                    },
    
                    /* {
                         key: 'edit',
                         name: 'Editar',
                         show: true
                     },*/
    
                ],
                dates: [],
                upbuton: 0,
                el_cotizacion: {
                    id: 0
                },
                open: false,
                user: user.getAll(),
                metodos_data: [],
                data: {},
                actionModal: null,
                viewCotizacion: false,
                showM: false,
                info: '',
                id: 0,
                obj_abono: {
                    cotizacion: 0,
                    tipo_pago: '',
                    impuesto: 0,
                    comision: 0,
                    total: 0,
                },
                addAbono: false,
                tipo_metodo: null,
                buscar: 'all',
                pagina: 1,
                limit: 0,
                reftable: 0,
                tipo: 'instaladores',
                fecha: [this.getFirstDayOfMonth(), this.getLastDayOfMonth()],
    
            }
    
        },
        mounted() {
            emitter.on('closeProduccion', () => {
    
                this.closeProduccion();
    
            });
        },
        async created() {
            if (this.$route.query.hasOwnProperty('cid')) {
                this.buscar = this.$route.query.cid;
            }
    
            await this.getData()
            await this.getDataMetodos();
        },
        methods: {
            IsMov() {
    
                //return true;
                return this.$isMobile()
            },
            accionProduccion(row) {
    
                this.el_cotizacion = row;
                this.viewCotizacion = true;
    
            },
            async pageChangue(val) {
    
                this.page = val;
                await this.getData();
    
            },
    
            infoModal(row) {
                this.info = row;
                
            },
            paginaSearch(pagina) {
               
                this.pagina = pagina;
    
                this.getData();
            },
    
            addRow() {
                this.showM = !this.showM;
                this.limpiar()
            },
            limpiar() {
                this.viewCotizacion = false;
            },
            closeProduccion() {
                this.viewCotizacion = false;
            },
            buscador(row) {
                if (String(row.telefono).toUpperCase().search(String(this.buscar).toUpperCase()) != -1 || (String(row.nombre)).toUpperCase().search(String(this.buscar).toUpperCase()) != -1) {
                    return true;
                } else {
                    return false;
                }
            },
            getColumns() {
                let col = 0;
                this.headings.forEach(element => {
                    if (element.show) {
                        col = col + 1
                    }
                });
                return col;
            },
    
            buscarGet(text) {
                this.buscar = text;
                if (text == '') {
                    this.buscar = 'all';
                }
                this.getData();
            },
    
            async getData() {
                this.showM = false;
                this.actionModal = null;
                emitter.emit("loading", true)
                let dat = {
                    search: this.buscar,
                    page: this.pagina,
                    tipo: this.tipo,
                }
                
                // Solo agregar parámetros de fecha si tienen valores
                if (this.fecha[0]) {
                    dat.inicio = this.formatDateEN(this.fecha[0]);
                }
                if (this.fecha[1]) {
                    dat.fin = this.formatDateEN(this.fecha[1]);
                }
                   // data: {}
    
                await cotizaciones.GET_PRODUCCION_AVANCE_05(dat).then(response => {
                    if (response != null && !response.hasOwnProperty('error')) {
                        this.data = response;
                        this.reftable = this.reftable + 1;
                    } else {
                        emitter.emit("alerta_show", response.error);
                    }
                    emitter.emit("loading", false)
                });
            },
    
            async Verificar(status) {
    
                let dat = {
                    id: this.el_cotizacion.id,
                    status_verificar: status,
                    observaciones_verificar: this.el_cotizacion.observaciones_verificar
    
                }
                if (status == 'APROBADA') {
                    dat.status_produccion = 'EN PRODUCCION'
                }
    
                if (this.el_cotizacion.id == 0) {
                    //this.crear(dat)
                } else {
                    this.editar(dat)
                }
            },
    
            async editar(dat) {
                emitter.emit("loading", true)
    
                await cotizaciones.EDITAR_PARAMS(dat).then(response => {
    
                    if (response != null && !response.hasOwnProperty('error')) {
    
                        this.el_cotizacion = response;
                        //this.$router.push('/app/'); 
                    } else {
    
                        // emitter.emit("alerta_show",response.msg);
    
                    }
                    this.showM = false;
                    this.limpiar();
                    emitter.emit("loading", false)
                });
            },

            // Métodos para filtros de fecha
            setCurrentMonth() {
                this.fecha = [this.getFirstDayOfMonth(), this.getLastDayOfMonth()];
                this.getData();
            },
            
            setPreviousMonth() {
                const now = new Date();
                const previousMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                const lastDayPreviousMonth = new Date(now.getFullYear(), now.getMonth(), 0);
                
                this.fecha = [this.formatDateEN(previousMonth), this.formatDateEN(lastDayPreviousMonth)];
                this.getData();
            },
            
            setLast3Months() {
                const now = new Date();
                // Fecha de inicio: primer día de hace 3 meses
                const threeMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 3, 1);
                // Fecha de fin: último día del mes actual
                const lastDayCurrentMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
                
                this.fecha = [this.formatDateEN(threeMonthsAgo), this.formatDateEN(lastDayCurrentMonth)];
                this.getData();
            },

            // Método para manejar cuando se marca una instalación
            onInstalacionMarcada() {
                // Recargar los datos de la tabla
                this.getData();
            }

        }
    }
    </script>
    